import styles from './Skeleton.styles';

const Skeleton = () => {
  return (
    <div className='Skeleton'>
      <style jsx>{ styles }</style>
    </div>
  );
};

export default Skeleton;
